import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("access_token");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    if (err?.response?.status === 402) {
      // Subscription blocked (past_due beyond grace / canceled). Redirect to
      // the fullscreen "Abbonamento bloccato" page — the only entry point
      // besides Abbonamento renewal & logout.
      const p = window.location.pathname;
      const allowed = ["/abbonamento-bloccato", "/admin/abbonamento", "/login", "/pagamento-completato"];
      if (!allowed.some((x) => p === x || p.startsWith(x + "/"))) {
        window.location.href = "/abbonamento-bloccato";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Errore imprevisto";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return JSON.stringify(d);
}

export default api;
